var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 358.8 179.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icp-orange",
    x1: 224.785,
    y1: 14.246,
    x2: 348.066,
    y2: 138.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icp-purple",
    x1: 133.946,
    y1: 165.574,
    x2: 10.665,
    y2: 41.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#522785"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icp-orange)",
    d: "M271.6 0c-20 0-41.9 10.9-65 32.4-10.9 10.1-20.5 21.1-27.5 29.8 0 0 11.2 12.9 23.5 26.8 6.7-8.4 16.2-19.8 27.3-30.1 20.5-19.2 33.9-23.1 41.6-23.1 28.8 0 52.2 24.2 52.2 54.1 0 29.6-23.4 53.8-52.2 54.1-1.4 0-3-.2-5-.6 8.4 3.9 17.5 6.7 26 6.7 52.8 0 63.2-36.5 63.8-39.1 1.5-6.7 2.4-13.7 2.4-20.9C358.6 40.4 319.6 0 271.6 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icp-purple)",
    d: "M87.1 179.8c20 0 41.9-10.9 65-32.4 10.9-10.1 20.5-21.1 27.5-29.8 0 0-11.2-12.9-23.5-26.8-6.7 8.4-16.2 19.8-27.3 30.1-20.5 19-34 23.1-41.6 23.1-28.8 0-52.2-24.2-52.2-54.1 0-29.6 23.4-53.8 52.2-54.1 1.4 0 3 .2 5 .6-8.4-3.9-17.5-6.7-26-6.7C13.4 29.6 3 66.1 2.4 68.8.9 75.5 0 82.5 0 89.7c0 49.7 39 90.1 87.1 90.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABE2",
    fillRule: "evenodd",
    d: "M127.3 59.7c-5.8-5.6-34-28.5-61-29.3C18.1 29.2 4 64.2 2.7 68.7 12 29.5 46.4.2 87.2 0c33.3 0 67 32.7 91.9 62.2l.1-.1s11.2 12.9 23.5 26.8c0 0 14 16.5 28.8 31 5.8 5.6 33.9 28.2 60.9 29 49.5 1.4 63.2-35.6 63.9-38.4-9.1 39.5-43.6 68.9-84.6 69.1-33.3 0-67-32.7-92-62.2l-.1.2s-11.2-12.9-23.5-26.8c.1 0-13.9-16.6-28.8-31.1Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcp);
export default __webpack_public_path__ + "static/media/icp.e4b8a460f696df6ab7b2c554237dde7e.svg";
export { ForwardRef as ReactComponent };